import React from 'react'
import Router from 'next/router'
import { toInnerFuncParam, startOnPageConstructor } from '../../../prefetchApi'

export function withPrefetchApi(pageConfig) {
  return function wrap(Component) {
    return class extends React.PureComponent {
      static displayName = `fwPageWithPrefetchApi(${
        Component.displayName || Component.name || 'Component'
      })`

      static async getInitialProps(ctx) {
        let pageProps
        if (Component.getInitialProps) {
          pageProps = await Component.getInitialProps(ctx)
        }
        // 需要异步等待的 server ssr 已在 withApp 处理
        // 其余均不支持异步（不阻塞业务）
        // 此处不做任何操作，均在 constructor 处理
        return {
          ...pageProps,
        }
      }

      constructor(props, ...rest) {
        super(props, ...rest)
        this.state = {
          prefetchApiInjectProps: {},
        }
        this._isLeave = false

        if (!props.ctx.__AL_EX_internalScope.isDisablePrefetchApiForRedirect) {
          const prefetchApiRenderProps = startOnPageConstructor(
            toInnerFuncParam(props.ctx, pageConfig, (propKey) => {
              // 注意，支持 callback，则 propKey 可能是新的、不存在于 prefetchApiRenderProps 的 key，即运行过程中新增 prop

              if (this._isLeave) {
                // 已离开时不再响应变化
                // TODO 如果路由失败，需要继续在当前页面上工作怎么办
                return
              }

              this.setState({
                prefetchApiInjectProps: { ...prefetchApiRenderProps },
              })
            })
          )
          this.state.prefetchApiInjectProps = prefetchApiRenderProps
        }

        this.handleRouteStart = this.handleRouteStart.bind(this)
        this.handleRouteComplete = this.handleRouteComplete.bind(this)
        this.handleRouteError = this.handleRouteError.bind(this)

        if (process.browser) {
          Router.events.on('routeChangeStart', this.handleRouteStart)
          Router.events.on('routeChangeComplete', this.handleRouteComplete)
          Router.events.on('routeChangeError', this.handleRouteError)
        }
      }

      componentWillUnmount() {
        Router.events.off('routeChangeStart', this.handleRouteStart)
        Router.events.off('routeChangeComplete', this.handleRouteComplete)
        Router.events.off('routeChangeError', this.handleRouteError)
      }

      handleRouteStart() {
        this._isLeave = true
      }

      handleRouteComplete() {
        this._isLeave = false
      }

      handleRouteError() {
        this._isLeave = false
      }

      render() {
        return (
          <Component {...this.props} {...this.state.prefetchApiInjectProps} />
        )
      }
    }
  }
}
